// @ts-nocheck
import { Provider } from '@angular/core';
import { NG_DOC_CONTEXT, NG_DOC_ROUTE_PREFIX, NG_DOC_SHIKI_THEME } from '@ng-doc/app/tokens';

export function provideNgDocContext(): Provider[] {
  return [{
    provide: NG_DOC_CONTEXT,
    useValue: {
      navigation: [
          
        {
          title: `API Reference`,
          route: '/ngdoc/api',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
          
        {
          title: `Apollo`,
          route: '/ngdoc/src',
          expandable: true,
          expanded: false,
          hidden: false,
          metadata: {"description":"","tags":{}},
          children: [
              
        {
          title: `Alert`,
          route: '/ngdoc/src/alert',
          hidden: false,
          metadata: {"description":"","tags":{"status":[":info New"]}},
        },
              
        {
          title: `Avatar`,
          route: '/ngdoc/src/avatar',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Badges`,
          route: '/ngdoc/src/badges',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Breadcrumb`,
          route: '/ngdoc/src/breadcrumb',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Buttons`,
          route: '/ngdoc/src/buttons',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Dropdown`,
          route: '/ngdoc/src/dropdown',
          hidden: false,
          metadata: {"description":"","tags":{"status":[":warning WIP"]}},
        },
              
        {
          title: `Icons`,
          route: '/ngdoc/src/icons',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Input`,
          route: '/ngdoc/src/text-input',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Modal: Confirm`,
          route: '/ngdoc/src/confirm',
          hidden: false,
          metadata: {"description":"","tags":{"status":[":warning WIP"]}},
        },
              
        {
          title: `Pagination`,
          route: '/ngdoc/src/pagination',
          hidden: false,
          metadata: {"description":"","tags":{"status":[":info New"]}},
        },
              
        {
          title: `Radio Buttons`,
          route: '/ngdoc/src/radio-buttons',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Skip Nav`,
          route: '/ngdoc/src/skip-nav',
          hidden: false,
          metadata: {"description":"","tags":{"status":[":info New"]}},
        },
              
        {
          title: `Tabs`,
          route: '/ngdoc/src/tabs',
          hidden: false,
          metadata: {"description":"","tags":{"status":[":info New"]}},
        },
              
        {
          title: `Textarea`,
          route: '/ngdoc/src/textarea',
          hidden: false,
          metadata: {"description":"","tags":{"status":[":warning WIP"]}},
        },
              
        {
          title: `Toast`,
          route: '/ngdoc/src/toast',
          hidden: false,
          metadata: {"description":"","tags":{"status":[":warning WIP"]}},
        },
              
        {
          title: `V3 Navigation`,
          route: '/ngdoc/src/layout-v3',
          hidden: false,
          metadata: {"description":"","tags":{"status":[":warning WIP"]}},
        },
          ]
        },
          
        {
          title: `Fresco`,
          route: '/ngdoc/fresco',
          expandable: true,
          expanded: false,
          hidden: false,
          metadata: {"description":"","tags":{}},
          children: [
              
        {
          title: `Fresco`,
          route: '/ngdoc/fresco/fresco',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Local Notification`,
          route: '/ngdoc/fresco/local-notification',
          hidden: false,
          metadata: {"description":"","tags":{"status":[":alert Deprecated"]}},
        },
          ]
        },
          
        {
          title: `LXP Shared`,
          route: '/ngdoc/lxp-shared',
          expandable: true,
          expanded: false,
          hidden: false,
          metadata: {"description":"","tags":{}},
          children: [
              
        {
          title: `Dgx Combobox`,
          route: '/ngdoc/lxp-shared/combobox',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
          ]
        },
      ],
    },
  }, {
    provide: NG_DOC_ROUTE_PREFIX,
    useValue: 'ngdoc',
  }, {
    provide: NG_DOC_SHIKI_THEME,
    useValue: {
      light: '',
      dark: '',
    },
  }];
}
